import { type CSSProperties, type MouseEvent } from 'react';
import cx from 'classnames';

import { IconMessageSquare_16 } from 'src/assets/icons/16x16/IconMessageSquare_16';
import { IconThumbsDown_16 } from 'src/assets/icons/16x16/IconThumbsDown_16';
import { IconThumbsUp_16 } from 'src/assets/icons/16x16/IconThumbsUp_16';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { type VoidFunction } from 'src/lib/types';

import styles from './SelectionToolbar.module.scss';

interface SelectionToolbarProps {
  className?: string;
  style: CSSProperties;
  onComment: VoidFunction;
  onThumbsUp: VoidFunction;
  onThumbsDown: VoidFunction;
}

// Keeps the text selection alive while a button is pressed.
const preventBlur = (event: MouseEvent) => event.preventDefault();

export const SelectionToolbar = ({
  className,
  style,
  onComment,
  onThumbsUp,
  onThumbsDown,
}: SelectionToolbarProps) => (
  <div
    className={cx(styles.root, className)}
    style={style}
    onMouseDown={preventBlur}
  >
    <CustomTooltip title="Comment">
      <CustomIconButton
        className={styles.button}
        size="small"
        onClick={onComment}
        data-testid="savedDocumentCommentButton"
      >
        <IconMessageSquare_16 />
      </CustomIconButton>
    </CustomTooltip>
    <CustomTooltip title="Thumbs up">
      <CustomIconButton
        className={styles.button}
        size="small"
        onClick={onThumbsUp}
        data-testid="savedDocumentThumbsUpButton"
      >
        <IconThumbsUp_16 />
      </CustomIconButton>
    </CustomTooltip>
    <CustomTooltip title="Thumbs down">
      <CustomIconButton
        className={styles.button}
        size="small"
        onClick={onThumbsDown}
        data-testid="savedDocumentThumbsDownButton"
      >
        <IconThumbsDown_16 />
      </CustomIconButton>
    </CustomTooltip>
  </div>
);
